<template>
  <v-container class="pa-0">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
    <v-card>
      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-0">Generacion de certificados</h3>
          <div>Programa: {{ programa.nombre_compuesto }}</div>
          <p v-if="programita.universidad" class="text-center text-success">En Convenio con: {{ programita.universidad.nombre }}</p>
        </div>
      </v-card-title>
      <v-card-text>
        <div class="xcard">
          <p class="text-center text-danger">
            <small> {{ msgimg }} </small>
          </p>

          <button class="btn btn-primary btn-sm" @click="iniciarGeneracion()">
            <span class="glyphicon glyphicon-check" style="color: white"></span> Generar Certificados de los que Faltan
          </button>
          <input
            :disabled="$store.state.CARGO.id == 13"
            type="checkbox"
            v-model="mostrarGrado"
            style="margin-left: 8px"
            title="Funcion no disponible para asesores."
          />
          Mostrar Grados Academicos
          <input type="text" class="form-control input-sm" style="max-width: 200px!; display: inline-block" v-model="buscar" placeholder="Buscar en la tabla" />
          <small class="xfuente">...</small>

          <Alertas ref="c_alertar" />
          <button class="btn btn-link btn-sm" @click="selcheck(true)"><span class="glyphicon glyphicon-check"></span> Todos</button>
          <button class="btn btn-link btn-sm" @click="selcheck(false)"><span class="glyphicon glyphicon-unchecked"></span> Ninguno</button>
          <button class="btn btn-link btn-sm" @click="seleccionarDiez()"><span class="glyphicon glyphicon-th-list"></span> De 10 en 10</button>

          <div class="table-responsive">
            <table ref="table" class="table table-condensed table-striped table-hover" id="midatatable">
              <thead>
                <tr>
                  <th><small>Nro</small></th>
                  <th><small>Estudiante</small></th>
                  <th><small>Documento</small></th>
                  <th><small>Tel.</small></th>
                  <th><small>Correo</small></th>
                  <th><small>Certificado</small></th>
                  <th style="min-width: 160px"><small>Opciones</small></th>
                </tr>
              </thead>

              <tbody>
                <tr v-bind:key="ind" v-for="(e, ind) in estudiantes">
                  <td>
                    <small>{{ ind + 1 }}</small>
                  </td>
                  <td>
                    <input :disabled="e.estado_ins == 0" type="checkbox" v-model="e.check" style="padding: 0; margin: 0" />
                    <small><input type="text" v-model="e.nombres" style="padding: 0; margin: 0; border: 0; width: 200px" /></small>
                  </td>
                  <td>
                    <small>{{ e.num_doc }}</small>
                  </td>
                  <td>
                    <small>{{ e.telefono1 }}</small>
                  </td>
                  <td>
                    <small>{{ e.email }}</small> <span style="display: none">{{ e.nombres }}</span>
                  </td>
                  <td>
                    <div v-if="e.estado == 3 || e.estado == 1" class="loader"></div>
                    <div v-else-if="e.estado == 2" class="dot-green"></div>
                    <small v-else> <span class="dot-red"></span> {{ parseEstado(e.estado) }} </small>
                    <small> {{ e.certificado_id }}</small>
                  </td>
                  <td>
                    <button
                      :disabled="!e.certificado_id"
                      title="Ver Certificado"
                      class="btn btn-xs btn-default"
                      data-toggle="modal"
                      data-target="#modal-cert"
                      @click="decargar(e, false)"
                    >
                      <span class="glyphicon glyphicon-eye-open"></span>
                    </button>
                    <button
                      v-show="sede_permitida"
                      :disabled="e.certificado_id || e.estado_ins == 0 || $store.state.CARGO.id == -13"
                      title="Generar Certificado"
                      class="btn btn-xs btn-default"
                      @click="generarCertificados(e, result, 2, 1)"
                    >
                      <span class="glyphicon glyphicon-refresh"></span>
                    </button>
                    <button
                      v-show="sede_permitida"
                      :disabled="!e.certificado_id || $store.state.CARGO.id == 13"
                      title="Anular Certificado"
                      class="btn btn-xs btn-default"
                      @click="preAnularcertificado(e)"
                    >
                      <span class="glyphicon glyphicon-trash"></span>
                    </button>
                    <button
                      v-show="sede_permitida"
                      :disabled="!(e.estado >= 2)"
                      title="Descargar Certificado"
                      class="btn btn-xs btn-default"
                      @click="decargar(e, true)"
                    >
                      <span class="glyphicon glyphicon-save"></span>
                    </button>
                    <button
                      v-show="sede_permitida"
                      :disabled="!(e.estado >= 2)"
                      title="Enviar por correo"
                      class="btn btn-xs btn-default"
                      @click="alistarUnPdfServer(e, 2, 1)"
                    >
                      <span class="glyphicon glyphicon-send"></span>
                    </button>
                    <button
                      v-show="sede_permitida"
                      :disabled="!(e.estado >= 2)"
                      title="Enviar por WhatsApp"
                      class="btn btn-xs btn-default"
                      @click="enviarPorWhatsapp(e)"
                    >
                      <span class="glyphicon glyphicon-comment"></span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div style="width: 10px !important; height: 1px !important; overflow: hidden">
            <canvas id="myCanvas3" style="border: 1px solid #55d3d3d3"></canvas>
          </div>
          <p class="text-primary">{{ mensaje }}</p>

          <notifications group="auth" position="bottom right" />
          <notifications group="auth3" position="bottom right" />
          <modalc id="modalemail" v-bind:correos="correos" v-bind:xbody="xbody" v-on:exito="modalExitoCorreo" />

          <div class="modal" tabindex="-1" role="dialog" id="modal-cert">
            <div class="modal-dialog" role="document">
              <div class="modal-content" style="overflow: hidden" id="content-preview">
                <div class="modal-header">
                  <h5 class="modal-title text-center"><b> Certificado </b></h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                </div>
                <div class="modal-body text-center">
                  <p class="text-primary text-center">{{ mensajito }}</p>
                  <canvas id="myCanvasview" style="border: 0px solid #55d3d3d3"></canvas>
                </div>
                <div class="modal-footer"><button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button></div>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="estudiantes.length > 15" small color="primary" rounded @click="iniciarGeneracion">
          <v-icon>mdi-checkbox-marked-circle-outline</v-icon> Generar Certificados de los que Faltan
        </v-btn>
        <v-btn small color="success" rounded :disabled="!descargartodo" @click="descargarTodos">
          <v-icon>mdi-file-download</v-icon> Descargar Certificados en PDF's
        </v-btn>
        <v-btn small color="warning" rounded :disabled="!descargartodo" @click="generarParaCorreos">
          <v-icon>mdi-email</v-icon> Enviar Certificados Por Correo a Todos
        </v-btn>
      </v-card-actions>
    </v-card>
    <template>
      <v-btn v-show="estudiantes.length > 15" small class="mx-4" @click="$router.back()" color="info" rounded outlined>
        <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
      </v-btn>
    </template>
  </v-container>
</template>
<script>
import Alertas from '@/components/AAlertas.vue';
import { parseJsonError, getCleanedString } from '@/components/Utils.js';
import modalc from '@/components/ACorreoCertificados.vue';
import gql from 'graphql-tag';
import { mapState } from 'vuex';
import xaxios from '@/xaxios';
export default {
  data() {
    return {
      is_fc_id498: false,
      is_formacion_continua: false,
      is_cca: false,
      pro: '',
      image: null,
      result: null,
      tam: 120,
      msgimg: '',
      xbody: `Hola $nombre, la *${process.env.VUE_APP_NAME}* le saluda y le felicita por tener a la institución como la primera opción para continuar con su desarrollo personal y profesional. \n\nPor este medio le envío el enlace de su certificado del: \n$pro, para que pueda descargarlo en formato PDF. \n\nAnte cualquier duda o consulta, no dude en contactarme por este medio, a fin de guiarle u orientarle. \n\n $link`,
      //xbody:'Hola $nombre, a continuacion le enviamos el link del certificado para descargarlo en formato PDF:',
      mensajito: 'Cargando vista previa....',
      mensaje: '',
      buscar: '',
      programita: { universidad: {} },
      descargartodo: false,
      idprograma: -1,
      estudiantes: [], //id_ins nombres num_doc email certificado_id estado_ins estado
      cetificados_uids: [], //inscripcion_id id codigo nro
      certificados: [],
      correos: [],
      correo: {},
      mostrarGrado: false,
      idsede: -1,

      c_indice: 0,
      sede_permitida: false,
    };
  },
  components: { modalc, Alertas },
  computed: { ...mapState({ programa: (state) => state.programa.value }) },
  watch: {
    buscar: function () {
      this.myFunction1(this.buscar);
    },
    mostrarGrado: function () {
      // window.console.log('\n\nCAMBIO\n\n', this.mostrarGrado);
      this.listarEstudiantes();
    },
    '$store.state.CARGOS': function () {
      if (this.idsede > 0) {
        this.isSedePermitida(this.idsede);
      }
    },
  },
  methods: {
    modalExitoCorreo() {},
    isSedePermitida(sede_actual) {
      var sed = this.$store.state.CARGOS.find((x) => x.idsede == sede_actual);
      this.sede_permitida = sed != null;
    },
    selcheck(estado) {
      this.c_indice = 0;
      this.estudiantes.forEach(function (e) {
        e.check = estado;
      });
    },
    seleccionarDiez() {
      this.estudiantes.forEach(function (e) {
        e.check = false;
      });
      var i = 0;
      for (i = this.c_indice; i < this.c_indice + 10; i++) {
        if (this.estudiantes.length > i) this.estudiantes[i].check = true;
      }
      this.c_indice = i;
      if (i > this.estudiantes.length) this.c_indice = 0;
    },
    parseEstado(es) {
      if (es == 0) return 'SIN CERTIFICADO';
      else if (es == 1) return 'GENERANDO...';
      else if (es == 2) return 'GENERADO';
      else if (es == 3) return 'DESCARGANDO...';
      else return 'nothing ';
    },
    wordWrapToStringList(text, maxLength) {
      var result = [],
        line = [];
      var length = 0;
      text.split(' ').forEach(function (word) {
        if (length + word.length >= maxLength) {
          result.push(line.join(' '));
          line = [];
          length = 0;
        }
        length += word.length + 1;
        line.push(word);
      });
      if (line.length > 0) {
        result.push(line.join(' '));
      }
      return result;
    },
    parseFecha(f) {
      if (f == null) return '';
      var fs = f.split('-');
      return fs[2] + '/' + fs[1] + '/' + fs[0];
    },
    parseMes(m) {
      m = m - 1;
      if (m == 0) return 'ENERO';
      else if (m == 1) return 'FEBRERO';
      else if (m == 2) return 'MARZO';
      else if (m == 3) return 'ABRIL';
      else if (m == 4) return 'MAYO';
      else if (m == 5) return 'JUNIO';
      else if (m == 6) return 'JULIO';
      else if (m == 7) return 'AGOSTO';
      else if (m == 8) return 'SEPTIEMBRE';
      else if (m == 9) return 'OCTUBRE';
      else if (m == 10) return 'NOVIEMBRE';
      else if (m == 11) return 'DICIEMBRE';
    },
    parsePrograma(p) {
      if (p == null) return '';
      let nombre = p.postgrado != null ? (nombre = p.postgrado.nombre) : '';
      nombre = nombre.replace(p.postgrado.categoria.nombre, '').replace('- ', '');
      return nombre + ' version:' + p.version + ', gestion:' + p.gestion;
    },
    cargarQRleft(sha, estudiante) {
      var p = `${process.env.VUE_APP_URL_WEBDATA}validador?idestudiante=esamestudent&idprograma=` + sha;
      var options = {
        text: p,
        width: 1024,
        height: 1024,
        version: 0,
        dotScale: 1,
        correctLevel: window.QRCode.CorrectLevel.L,
        onRenderingEnd: this.renderingEnd(),
      };
      //estudiante.qr1 = qr.toImage("png");
      new window.QRCode(document.getElementById('qrcode1'), options);
      estudiante.qr1 = document.getElementById('qrcode1').childNodes[0];
    },
    cargarQRRight(es) {
      var str = 'DATOS:\n\n';
      str += 'Estudiante: ' + es.nombres + '\n';
      str += '\n\n' + this.programita.postgrado.nombre.toUpperCase();
      str += '\n\nRealizado del ' + this.parseFecha(this.programita.fecha_inicio) + ' AL ' + this.parseFecha(this.programita.fecha_fin);
      var p = str;
      /*var qr = new window.VanillaQR({
        url: p,
        width: 150,
        height: 150,
        colorLight: "#FFFFFF",
        colorDark: "#000000",
        toTable: false,
        ecclevel: 1,
        noBorder: true,
        borderSize: 4,
      });*/
      var options = {
        text: p,
        width: 1024,
        height: 1024,
        version: 0,
        dotScale: 1,
        correctLevel: window.QRCode.CorrectLevel.L,
        onRenderingEnd: this.renderingEnd(),
      };
      //es.qr2 = qr.toImage("png");
      new window.QRCode(document.getElementById('qrcode2'), options);
      es.qr2 = document.getElementById('qrcode2').childNodes[0];
    },
    renderingEnd() {},
    cargarDatosCanvasCCA(certificado, estudiante) {
      //certificado.lugar = certificado.lugar.replace("DE LA SIERRA","");
      certificado.curso = certificado.curso.replace('CURSO EN ', '');
      var canvas = document.getElementById('myCanvas3').cloneNode(true);
      /*canvas.style.width = "1280px";
      canvas.style.height = "908px";*/
      canvas.width = 1280;
      canvas.height = 908;
      var context = canvas.getContext('2d');

      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(this.image, 0, 0, 1280, 908);

      context.font = '10px Arial';
      context.fillText('verificador:', 130, 755);
      context.drawImage(estudiante.qr1, 90, 758, this.tam, this.tam);
      context.drawImage(estudiante.qr2, 1065, 758, this.tam, this.tam);
      context.fillText('estudiante:', 1095, 755);

      context.fillStyle = '#eeffff';
      context.font = '200 14px xfuente';
      context.fillText('000000000' + certificado.nro, canvas.width / 2 + 525, 25);
      context.fillStyle = '#000000';

      var times = certificado.fecha_registro.split('T')[0];
      var fecha = times;
      var ps = fecha.split('-');
      var dia = ps[2];
      var mes = ps[1];
      var anio = ps[0];
      var messtr = this.parseMes(mes);
      dia = parseInt(dia);

      context.font = '200 30px xfuente';
      context.textAlign = 'center';

      context.fillText('' + estudiante.nombres, canvas.width / 2 + 100, 505);
      var pp = certificado.curso;
      if (pp.length > 65) {
        pp = this.wordWrapToStringList(pp, 65);
        // window.console.log( pp )
        var tt = 585;
        //var vue = this;
        pp.forEach(function (e) {
          context.font = '200 23px xfuente';
          context.fillText('' + e, canvas.width / 2 + 50, tt);
          tt += 22;
        });
      } else {
        context.font = '200 30px xfuente';
        context.fillText('' + pp, canvas.width / 2 + 50, 595);
      }
      context.font = '200 23px xfuente';
      context.fillText('' + certificado.carga_horaria, canvas.width / 2 + 10, 644);
      //context.fillText(""+certificado.lugar, (canvas.width/2)-100, 678);
      context.fillText('' + dia, canvas.width / 2 - 80, 680);
      context.fillText('' + messtr, canvas.width / 2 + 180, 680);
      context.fillText('' + anio, canvas.width / 2 + 360, 680);

      estudiante.canvas = canvas;
    },

    listarEstudiantes() {
      this.estudiantes = [];
      this.$refs.c_alertar.cargando();
      var vue = this;
      var sql = gql`query{ getPrograma(id:${this.idprograma}){arte,fecha_inicio,fecha_fin,postgrado{categoria{nombre},nombre,carga_horaria},universidad{nombre,convenio,id},sede{id,nombre,ciudad{nombre}},inscripciones{certificado_id,id,estado_ins,fecha_registro,asesor{id},estudiante{email,num_doc,telefono1,usuario_moodle,clave_moodle,nombres,pri_apellido,seg_apellido,departamento{extension},estado,grados{id nombre abreviatura titulo nivel}},asesor{num_doc,num_doc,nombres,pri_apellido,seg_apellido}}}}`;
      // window.console.log( sql );

      this.$apollo
        .query({
          query: sql,
        })
        .then((data) => {
          var participantes = [];
          var res = data.data.getPrograma;
          this.result = res;

          res.inscripciones.forEach(function (e) {
            var est = e.estudiante;
            var am = est.seg_apellido;
            if (!am) am = '';
            var nom = est.nombres + ' ' + est.pri_apellido + ' ' + am;
            var estado = 0;
            if (e.certificado_id) estado = 2;
            var estudiante = {
              id_ins: e.id,
              nombres: nom.toUpperCase(),
              num_doc: est.num_doc,
              email: est.email,
              check: e.estado_ins > 0,
              certificado_id: e.certificado_id,
              estado_ins: e.estado_ins,
              telefono1: est.telefono1,
              estado: estado,
              grados: vue.sortGrados(est.grados),
              qr1: null,
              qr2: null,
            };

            if (vue.mostrarGrado) {
              if (estudiante.grados[0]) {
                estudiante.nombres = estudiante.grados[0].abreviatura + ' ' + estudiante.nombres;
                estudiante.nombres = estudiante.nombres.toUpperCase();
              }
            }
            participantes.push(estudiante);
            if (e.certificado_id) vue.getCertificado(e.certificado_id);
          });

          var fondo_certificado = res.arte;
          if (fondo_certificado) {
            window.console.log('res.arte', res.arte);
            fondo_certificado = process.env.VUE_APP_URL_CERT_PROGRAMAS + res.arte;
            if (fondo_certificado.endsWith('.jpg' || '.png')) this.cargarFondoCertificado(fondo_certificado);
          }
          window.console.log('FONDO CERT------ ', fondo_certificado);

          participantes.sort(function (a, b) {
            return b.estado_ins - a.estado_ins;
          });
          this.estudiantes = participantes;
          this.descargartodo = true;
          // window.console.log( this.programita )
          // window.console.log( res )
          this.$refs.c_alertar.reset();
          this.idsede = res.sede.id;
          this.isSedePermitida(this.idsede);
        })
        .catch((error) => {
          window.console.error(error);
          vue.$refs.c_alertar.reset();
          vue.$notify(parseJsonError(error, 'getPrograma'));
        });
    },
    sortGrados(grados) {
      //window.console.log( "SORCILLO:: ",grados )
      if (!grados) return [];
      grados = grados.sort(function (a, b) {
        return a.nivel - b.nivel;
      });
      //window.console.log( "GRADOS SORT:: ",grados )
      return grados;
    },

    iniciarGeneracion() {
      var vue = this;
      var tam = this.estudiantes.length;
      this.estudiantes.forEach(function (e, index) {
        if (e.check) {
          if (e.certificado_id) {
            tam = tam - 1;
            vue.getCertificado(e.certificado_id);
          } else if (e.estado_ins > 0) {
            vue.generarCertificados(e, vue.result, tam, index);
          }
        }
      });
    },

    generarCertificados(estudiante, programa, tam, index) {
      window.console.log('TAM, INDEX: ', tam, index);
      estudiante.estado = 1;
      let datos = {},
        nombre = programa.postgrado.nombre;
      nombre = nombre.replace(programa.postgrado.categoria.nombre, '').replace('- ', '');
      datos.curso = nombre.toUpperCase();
      datos.emisor = programa.universidad.nombre.toUpperCase();
      datos.lugar = programa.sede.ciudad.nombre.toUpperCase();
      datos.carga_horaria = programa.postgrado.carga_horaria;
      datos.fecha_inicio = programa.fecha_inicio;
      datos.fecha_fin = programa.fecha_fin;
      // datos.imagen_fondo = "sigloxx"; //default
      datos.imagen_fondo = programa.arte;
      datos.estudiantes = [];
      datos.estudiantes.push({ inscripcion_id: estudiante.id_ins, estudiante: estudiante.nombres });
      // window.console.log( "DATOSSS: ",window.stringifyObject(datos) )

      var sql = gql`mutation{ generarCertificados(input:${window.stringifyObject(datos)}){ ok certificados{inscripcion_id id codigo nro} errors{message} } }`;
      // window.console.log( sql,res );

      this.$apollo
        .query({
          query: sql,
        })
        .then((data) => {
          var res = data.data.generarCertificados;
          //window.console.log( "DATOS DEL SERVER generarCertificados: ",window.stringifyObject(res) )
          var cer = res.certificados[0];
          var est = this.estudiantes.find((x) => x.id_ins == cer.inscripcion_id);
          if (est) {
            est.certificado_id = cer.id;
            est.estado = 2;
            this.getCertificado(cer.id);
          }
          this.cetificados_uids.push(res.certificados[0]);
          this.descargartodo = true;
        })
        .catch((error) => {
          this.msg = error;
          estudiante.estado = 1010;
          window.console.error(error);
        });
    },
    getCertificado(id_cert) {
      var sql = gql`query{ getCertificadoById(id:${id_cert}){id codigo nro curso estudiante emisor lugar carga_horaria fecha_inicio fecha_fin fecha_registro imagen_fondo estado} }`;
      this.$apollo
        .query({
          query: sql,
        })
        .then((data) => {
          var res = data.data.getCertificadoById;
          //this.cetificados_uids.push( res )
          if (res) {
            this.certificados.push(res);
            var est = this.estudiantes.find((x) => x.certificado_id == id_cert);
            est.nombres = res.estudiante;
          }
          //window.console.log( "DATOS DEL SERVER: ",window.stringifyObject(res),this.cetificados_uids )
        })
        .catch((error) => {
          this.msg = error;
          window.console.error(error);
        });
    },
    /** ANULAR CERTIFICADO GENERADO */
    preAnularcertificado(estudiante) {
      var vue = this;
      var opt = {
        verification: 'anular',
        verificationHelp: 'Escriba "[+:verification]" para anular este certificado.',
        okText: 'Anular certificado',
        cancelText: 'cancelar',
        backdropClose: false,
        animation: 'bounce',
        loader: true,
        type: 'hard',
      };
      var message = {
        title: 'Confirmar anulacion',
        body: '<br> <b>NOTA:</b> Al anular el certificado se genera un nuevo numero de cetificado y se establece la fecha de hoy.',
      };
      this.$dialog
        .confirm(message, opt)
        .then(function (dialog) {
          vue.anularCertificado(estudiante, dialog);
        })
        .catch(function () {});
      return;
    },
    anularCertificado(estudiante, dialog) {
      var sql = gql`mutation{ cambiarEstadoCertificado(input:{ id:${estudiante.id_ins} estado: false }){ ok certificado{id inscripcion_id codigo nro} errors{message} } }`;
      // window.console.log( "cambiarEstadoCertificado",sql )
      this.$apollo
        .mutate({
          mutation: sql,
        })
        .then((data) => {
          var datos = data.data.cambiarEstadoCertificado;
          // window.console.log( "ELIMINADO ",window.stringifyObject(datos) )
          if (datos.ok) {
            //estudiante.certificado_id = null;
            estudiante.estado = 0;
            this.anularPdfExiste(estudiante);
          }
          dialog.close();
        })
        .catch((error) => {
          this.msg = error;
          window.console.error(error);
        });
    },
    /** FIN ANULAR CERTIFICADO */

    descargarTodos() {
      this.mensaje = '';
      var vue = this;
      var descargados = 0;
      var nodescargados = 0;
      this.estudiantes.forEach(function (e) {
        if (e.estado_ins > 0 && e.certificado_id) {
          if (e.check) {
            descargados += 1;
            vue.decargar(e, true);
          } else {
            nodescargados += 1;
          }
        } else {
          nodescargados += 1;
        }
      });
      this.mensaje =
        'REPORTE: ' +
        descargados +
        ' Generados, ' +
        nodescargados +
        ' No Generados. \nRecuerde que los participantes deben tener un certificado generado para usar esta funcionalidad.';
    },
    decargar(estudiante, savePDF) {
      var cer = this.certificados.find((cert) => cert.id == estudiante.certificado_id);
      // window.console.log('this.certificados', this.certificados);
      // window.console.log('this.cetificados_uids', this.cetificados_uids);
      // window.console.log('cer', cer);
      window.console.log('estudiante', estudiante);
      if (cer) {
        estudiante.estado = 3;
        this.mensajito = 'Cargando vista previa...';

        if (estudiante.qr1 && estudiante.qr2 && estudiante.canvas) {
          if (savePDF) this.guardar(estudiante);
          else {
            estudiante.estado = 2;
            var vue = this;
            setTimeout(() => {
              vue.previewCertificado(estudiante);
            }, 350);
          }
        } else {
          this.cargarQRleft(cer.codigo, estudiante);
          this.cargarQRRight(estudiante);
          // window.console.log( "Cargando..." )
          setTimeout(() => {
            this.cargarDatosCanvasCCA(cer, estudiante);
            if (savePDF) this.guardar(estudiante);
            else {
              estudiante.estado = 2;
              this.previewCertificado(estudiante);
            }
          }, 1500);
        }
      } else {
        window.console.log('No hay certificado: ' + estudiante.id_ins);
        window.alert('No hay certificado: ' + estudiante.nombres);
      }
    },
    guardar(estudiante) {
      let width = estudiante.canvas.width;
      let height = estudiante.canvas.height;
      var pdf;

      if (width > height) {
        pdf = new window.jsPDF('l', 'px', [width, height]);
      } else {
        pdf = new window.jsPDF('p', 'px', [height, width]);
      }

      width = pdf.internal.pageSize.getWidth();
      height = pdf.internal.pageSize.getHeight();
      pdf.addImage(estudiante.canvas, 'PNG', 0, 0, width, height);
      pdf.save(estudiante.nombres + '.pdf');
      estudiante.estado = 2;
    },

    previewCertificado(estudiante) {
      var modalsize = document.getElementById('content-preview').getBoundingClientRect();
      var a = ((modalsize.width - 30) * 100) / estudiante.canvas.width / 100;
      var destinationCanvas = document.getElementById('myCanvasview');
      var destCtx = destinationCanvas.getContext('2d');
      destinationCanvas.width = estudiante.canvas.width;
      destinationCanvas.height = estudiante.canvas.height / 2;
      destCtx.scale(a, 0.4);
      destCtx.drawImage(estudiante.canvas, 0, 0);
      this.mensajito = '';
    },

    generarParaCorreos() {
      this.mensaje = '';
      var vue = this;
      vue.correos = [];
      var inscritos = [];
      var descargados = 0;
      var nodescargados = 0;

      this.estudiantes.forEach(function (e) {
        if (e.estado_ins > 0 && e.certificado_id) {
          if (e.check) {
            descargados += 1;
            inscritos.push(e);
          } else {
            nodescargados += 1;
          }
        } else {
          nodescargados += 1;
        }
      });

      var tam = inscritos.length;
      inscritos.forEach(function (e, index) {
        vue.alistarPdfServer(e, tam, index);
      });

      this.mensaje =
        'REPORTE: ' +
        descargados +
        ' Generados, ' +
        nodescargados +
        ' No Generados. \nRecuerde que los participantes deben tener un certificado generado para usar esta funcionalidad.';
    },
    enviarPorWhatsapp(estudiante) {
      this.alistarUnPdfServer(estudiante, 0, 1); // para no mostrar el modal de correo
      if (!estudiante.telefono1) {
        window.alert('Este estudiante no tiene numero de telefono.');
        return;
      }
      var filepdf = this.generarNombrePdf(estudiante);
      var link = process.env.VUE_APP_URL_CERTIFICADOS + filepdf;
      var ppr = this.programita.postgrado.categoria.nombre + ' ' + this.pro;
      ppr = ppr.replace('CURSOS DE FORMACIÓN CONTINUA CURSOS DE FORMACIÓN CONTINUA', 'CURSO ');
      ppr = ppr.toUpperCase();
      //var txt = "La *UNSXX y ESAM* le saluda y le felicita por tener a la institución como la primera opción para continuar con su desarrollo profesional, por este medio le envío sus datos de acceso a la Plataforma Virtual, para acceder a los contenidos, trabajos prácticos y calificaciones de los módulos. \n\nAnte cualquier duda o consulta, no dude en contactarme por este medio, a fin de guiarle u orientarle. \n\n";
      var txt =
        'Hola ' +
        estudiante.nombres +
        ', *ESAM* le saluda y le felicita por tener a la institución como la primera opción para continuar con su desarrollo personal y  profesional, por este medio le envío el enlace de su certificado del: \n*' +
        ppr +
        '* para que pueda descargarlo en formado PDF. \n\nAnte cualquier duda o consulta, no dude en contactarme por este medio, a fin de guiarle u orientarle. \n\n' +
        link;
      //var txt = "Hola "+estudiante.nombres+", le enviamos el link del certificado del: "+this.pro+" para descargarlo en formato PDF: "+link;
      txt = encodeURIComponent(txt);
      window.open(`${process.env.VUE_APP_API_WHATSAPP}591${estudiante.telefono1}&text=${txt}`);
    },
    alistarUnPdfServer(estudiante, tam, index) {
      this.correos = [];
      this.alistarPdfServer(estudiante, tam, index);
    },
    alistarPdfServer(estudiante, tam, index) {
      var cer = this.certificados.find((x) => x.id == estudiante.certificado_id);
      window.console.log(this.certificados, this.cetificados_uids, '---', cer, estudiante);
      if (cer) {
        estudiante.estado = 3;

        if (estudiante.qr1 && estudiante.qr2 && estudiante.canvas) {
          this.verificarPdfExiste(estudiante, tam, index);
        } else {
          this.cargarQRleft(cer.codigo, estudiante);
          this.cargarQRRight(estudiante);
          window.console.log('Alistar pdf Cargando...');
          setTimeout(() => {
            this.cargarDatosCanvasCCA(cer, estudiante);
            this.verificarPdfExiste(estudiante, tam, index);
          }, 1400);
        }
      } else {
        window.console.log('No hay certificado: ' + estudiante.id_ins);
      }
    },
    verificarPdfExiste(estudiante, tam, index) {
      var nombre = this.generarNombrePdf(estudiante);

      var formData = new FormData();
      formData.append('nombre', nombre);

      var vue = this;
      window.jQuery.support.cors = true;
      window.$.ajax({
        method: 'POST',
        headers: { credentials: 'false' },
        url: `${process.env.VUE_APP_URL_WEBDATA}certificado2.php`,
        data: formData,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          // window.console.log( "verificado." )
          // window.console.log(data,"PDF?CUSTOM: ",nombre);
          if (data.estado) {
            vue.armarCorreo(estudiante, data, tam, index); // momentaneamente
            //vue.subirPDF( estudiante,tam,index );
          } else {
            vue.subirPDF(estudiante, tam, index);
          }
        })
        .catch(function (e) {
          estudiante.estado = 10101; //algun error
          window.console.log(e);
        });
    },
    subirPDF(estudiante, tam, index) {
      estudiante.estado = 3;
      let width = estudiante.canvas.width;
      let height = estudiante.canvas.height;
      var pdf;
      var nombre = this.generarNombrePdf(estudiante);

      if (width > height) {
        pdf = new window.jsPDF('l', 'px', [width, height]);
      } else {
        pdf = new window.jsPDF('p', 'px', [height, width]);
      }

      width = pdf.internal.pageSize.getWidth();
      height = pdf.internal.pageSize.getHeight();
      pdf.addImage(estudiante.canvas, 'PNG', 0, 0, width, height);
      //pdf.save( nombre );

      var arc = pdf.output('blob');

      var formData = new FormData();
      formData.append('nombre', nombre);
      formData.append('file', arc);
      window.console.log('subiendo pdf.');

      var vue = this;
      window.jQuery.support.cors = true;
      window.$.ajax({
        method: 'POST',
        headers: { credentials: 'false' },
        url: `${process.env.VUE_APP_URL_WEBDATA}certificados.php`,
        data: formData,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          // window.console.log( "subido." )
          // window.console.log(data,"PDF?CUSTOM: ",nombre);

          vue.armarCorreo(estudiante, data, tam, index);
        })
        .catch(function (e) {
          estudiante.estado = 10101; //algun error
          window.console.log(e);
        });
    },
    armarCorreo(estudiante, data, tam, index) {
      window.console.log('PROGRAMITA::', this.programita);
      estudiante.estado = 2;
      var correo = {};
      let filePdf = process.env.VUE_APP_URL_CERTIFICADOS + data.file;
      let link = `<p><a href="${filePdf}" download><b>Toca aqui para descargar tu certificado</b></a> </p>`;
      correo.xid = -1;
      correo.xtitle = 'Enviar Certificado al Estudiante';
      (correo.xbody = `Hola ${estudiante.nombres}, *${process.env.VUE_APP_NAME}* le saluda y le felicita por tener a la institución como la primera opción para continuar con su desarrollo personal y profesional.\n\n
        Por este medio le envío el enlace de su certificado de:\n ${this.pro}, \n
        para que pueda descargarlo en formato PDF.\n\n
        Ante cualquier duda o consulta, no dude en contactarme por este medio, a fin de guiarle u orientarle. \n\n ${link} \n\n
        para verificar su certificado puede urilizar la app https://play.google.com/store/apps/details?id=com.apple.qrcode.reader y escanear el codigo del certificado`),
        (correo.xlink = link);
      correo.xestudiante = estudiante.nombres;
      var xxxxp = this.programita.postgrado.categoria.nombre + ' ' + this.pro;
      xxxxp = xxxxp.toUpperCase();
      xxxxp = xxxxp.replace('CURSOS DE FORMACIÓN CONTINUA', '');
      xxxxp = xxxxp.replace('CURSOS', 'Curso');
      correo.xpro = xxxxp;
      correo.all = false;
      correo.isDefault = true;
      correo.xsql = null;
      correo.xcorreo = estudiante.email;
      //correo.xcorreo = 'eclipseconsol@gmail.com';
      correo.xnombre = `${process.env.VUE_APP_NAME} Certificado`;
      correo.xasunto = `${process.env.VUE_APP_NAME} Certificado`;
      correo.xestado = '';
      this.correos.push(correo);

      window.console.log('CORREO SERVER: ', tam, index);
      if (tam - 1 == index) {
        this.mostrarModalCorreo();
      }
    },

    anularPdfExiste(estudiante) {
      const url = `${process.env.VUE_APP_URL_WEBDATA}certificadodel.php`;
      xaxios.post(url, { nombre: this.generarNombrePdf(estudiante) }).then(({ data }) => {
        this.$root.$notify.show(`${data.msg}`, { color: data.estado ? 'success' : 'red' });
      });
    },

    mostrarModalCorreo() {
      window.console.log(this.correos);
      window.$('#modalemail').modal('show');
    },

    generarNombrePdf(estudiante) {
      var nombre = estudiante.nombres;
      nombre = getCleanedString(nombre);
      nombre = nombre.toLowerCase() + '_' + estudiante.id_ins + '_' + estudiante.certificado_id + '.pdf';
      return nombre;
    },

    cargarFondoCertificado(img) {
      var vue = this;
      this.msgimg = 'Cargando imagen del certificado...';
      this.image.src = img;
      this.image.setAttribute('crossorigin', 'anonymous'); // evita un error que da jsPdf.js
      this.image.onload = function () {
        var canvas = document.getElementById('myCanvas3');
        var context = canvas.getContext('2d');
        context.drawImage(vue.image, 0, 0, 1280, 908);
        vue.msgimg = '';
      };
    },

    myFunction1(filtro) {
      filtro = filtro.toUpperCase();
      var table, tr, tdd, td, i, j, txtValue;
      table = document.getElementById('midatatable');
      tr = table.getElementsByTagName('tr');
      for (i = 0; i < tr.length; i++) {
        tdd = tr[i].getElementsByTagName('td');
        for (j = 1; j < tdd.length; j++) {
          td = tdd[j];
          if (td) {
            txtValue = td.textContent;
            if (txtValue.toUpperCase().indexOf(filtro) > -1) {
              tr[i].style.display = '';
              break;
            } else {
              tr[i].style.display = 'none';
            }
          }
        }
      }
    },
  },
  mounted() {
    var vue = this;
    var p = this.programa;
    // window.console.log('mountend p', p);
    this.pro = this.parsePrograma(p);
    this.image = new Image();
    let img = process.env.VUE_APP_URL_CERT_PROGRAMAS + p.arte; // option two
    window.console.log('this.image.src', p, img);
    this.cargarFondoCertificado(img);

    this.programita = p;
    this.sede_certificado = p.sede.id == this.$store.state.CARGO.idsede;
    if (p) {
      this.idprograma = p.id;
      this.listarEstudiantes();
    }

    window.$('#modal-cert').on('hidden.bs.modal', function () {
      var destinationCanvas = document.getElementById('myCanvasview');
      var destCtx = destinationCanvas.getContext('2d');
      destCtx.clearRect(0, 0, destinationCanvas.width, destinationCanvas.height);
      destinationCanvas.width = 0;
      destinationCanvas.height = 0;
      vue.mensajito = '';
    });
  },
};

// 3.CAMBIO PARA MANEJAR SEDE GENERAL CIBERKIDS (YA NO SUCRE Y TARIJA)
//         -ciberkids Santa Cruz
//         -ciberkids GENERAL

// 5. INCLUIR CODIGO RUDE/CI PARA LOS NIÑOS COMO OPCION
//         -generar automaticamente rude en caso de no existir CI
//         -obligar dato ciudad de residencia
//         -button create ciudadad
// 6. EN LOS TIPOS DE CURSO SE DEBE INCLUIR EL ATRIBUTO DE CURSO
//  ( SEGUN DOCUMENTO QUE SE ENCUENTRA EN CARPETA) E INCLUIR LA OPCION PARA CREAR CURSOS MODULARES GRADUALES
//         -filtrar sede, nombre categoria
// - falta filtro esam
// 7. CAMBIO DE LA MISION/ VISION, SEGUN INFORMACION QUE SE ENCUENTRA EN LA CARPETA

// 8. CAMBIO DE LOS RECIBOS
//     -vincular al momento de pagar la tabla recibo al pago de cuotas, matriculas, certificciones,
//     - generar automanticamente la numeacion.
//     -Y CERTIFICADOS.

//     - reporte de inscritos por asesor por mes y programa, rango de fechas,
//     - generar usuarios en el entorno de prueba

//     - generar automanticamente la numeacion.
// ==================
//     -vincular al momento de pagar la tabla recibo al pago de cuotas, matriculas, certificciones,
//         -generar automaticamente rude en caso de no existir CI
//         -ciberkids Santa Cruz
//         -ciberkids GENERAL
//     - reporte de inscritos por asesor por mes y programa, rango de fechas,
</script>
<style lang="css">
.dot-green {
  height: 10px;
  width: 10px;
  background-color: #00aa00;
  border-radius: 50%;
  display: inline-block;
}
.dot-red {
  height: 10px;
  width: 10px;
  background-color: #aa0000;
  border-radius: 50%;
  display: inline-block;
}

.loader {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid blue; /* Blue */
  border-bottom: 4px solid blue;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1.2s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
